module.exports = __webpack_public_path__ + "img/imgImgHomeLB02.d0fb1d6f.svg";